var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

// timeline section Core js
document.querySelectorAll('.Timeline__NavItem').forEach(item => {
  item.addEventListener('click', event => {
    var el = item;
    var index = item.getAttribute('data-index');
    var size = document.getElementsByClassName('Timeline__NavItem').length;
    for(i=0; i< size; i++){
     document.getElementsByClassName('Timeline__NavItem')[i].classList.remove('is-selected');
    }
    item.classList.add('is-selected');
    for(i=0; i< size; i++){
     document.getElementsByClassName('Timeline__Item')[i].classList.remove('is-selected');
    }
    document.getElementsByClassName('Timeline__Item')[index].classList.add('is-selected');
  });
});